interface SetDiff {
  <T>(setA: Set<T>, setB: Set<T>): boolean;
}

export const doSetsDiffer: SetDiff = (setA, setB) => {
  if (setA.size !== setB.size) {
    return true;
  }

  return [...setA].some((e) => !setB.has(e));
};
